// Generated by @shh/design-tokens – do not edit.
export const tokens = {
  "color": {
    "fog": {
      "50": "#f8f9f6",
      "100": "#eceeea",
      "200": "#dde2dd",
      "300": "#c6cec8",
      "400": "#9ba8a2",
      "500": "#74847d",
      "600": "#52635d",
      "700": "#435550",
      "800": "#2c3c38",
      "900": "#1a2926",
      "950": "#0e1715"
    },
    "pine": {
      "50": "#e8f1ee",
      "100": "#cfe2db",
      "200": "#a2c8ba",
      "300": "#6fa894",
      "400": "#468a74",
      "500": "#2e6f5a",
      "600": "#245a4a",
      "700": "#1f4a3e",
      "800": "#1c3d34",
      "900": "#1c332e",
      "950": "#0f1d1a"
    },
    "lingon": {
      "50": "#fbedef",
      "100": "#f5d3d8",
      "200": "#eba7b1",
      "300": "#de7a89",
      "400": "#cc5467",
      "500": "#b83f52",
      "600": "#9e3343",
      "700": "#7e2936",
      "800": "#5e1f29",
      "900": "#3f151c"
    },
    "fjord": {
      "50": "#eaf1f6",
      "100": "#cfe0eb",
      "200": "#a2c2d8",
      "300": "#71a0c0",
      "400": "#4d82a7",
      "500": "#3d6a8a",
      "600": "#325771",
      "700": "#284659",
      "800": "#1e3543",
      "900": "#14242d"
    },
    "brass": {
      "50": "#fbf5e6",
      "100": "#f5e7c0",
      "200": "#edd28a",
      "300": "#e4bb55",
      "400": "#d9a632",
      "500": "#b8912a",
      "600": "#957421",
      "700": "#72581a",
      "800": "#513f13",
      "900": "#33280c"
    },
    "moss": {
      "50": "#edf4ef",
      "100": "#d4e6d9",
      "200": "#aacdb4",
      "300": "#7db08d",
      "400": "#5a956c",
      "500": "#4f8566",
      "600": "#3f6b52",
      "700": "#31543f",
      "800": "#243e2e",
      "900": "#172920"
    },
    "coral": {
      "50": "#fdf0eb",
      "100": "#fadcd0",
      "200": "#f5b8a2",
      "300": "#ee9070",
      "400": "#e56f4a",
      "500": "#d2552f",
      "600": "#ae4424",
      "700": "#87351d",
      "800": "#612716",
      "900": "#3f190e"
    },
    "heather": {
      "50": "#f1f0f6",
      "100": "#dedcea",
      "300": "#a7a3c6",
      "500": "#6d6a8f",
      "600": "#585575",
      "700": "#45435c",
      "800": "#312f42",
      "900": "#211f2d"
    },
    "surface": {
      "canvas": "#eceeea",
      "raised": "#f8f9f6",
      "sunken": "#dde2dd",
      "overlay": "#f8f9f6",
      "inverse": "#1c332e",
      "scrim": "rgba(28, 51, 46, 0.4)",
      "band": "#1f4a3e"
    },
    "text": {
      "primary": "#1c332e",
      "secondary": "#435550",
      "muted": "#52635d",
      "inverse": "#f8f9f6",
      "on-action": "#f8f9f6",
      "link": "#325771",
      "on-band": "#f8f9f6"
    },
    "border": {
      "subtle": "#dde2dd",
      "default": "#c6cec8",
      "strong": "#74847d",
      "focus": "#3d6a8a",
      "card": "var(--shh-color-border-subtle)"
    },
    "block": "#1c332e",
    "action": {
      "primary": "#1f4a3e",
      "primary-hover": "#1c3d34",
      "primary-pressed": "#1c332e",
      "secondary": "#dde2dd",
      "secondary-hover": "#c6cec8",
      "secondary-pressed": "#c6cec8",
      "on-secondary": "#1c332e",
      "quiet-hover": "rgba(28, 51, 46, 0.0784313725490196)",
      "disabled": "#dde2dd",
      "on-disabled": "#52635d"
    },
    "accent": {
      "primary": "#b83f52",
      "primary-soft": "#fbedef",
      "secondary": "#3d6a8a",
      "secondary-soft": "#eaf1f6",
      "tertiary": "#957421",
      "tertiary-ink": "#72581a",
      "tertiary-soft": "#fbf5e6",
      "on-accent": "#f8f9f6"
    },
    "feedback": {
      "success": "#3f6b52",
      "success-surface": "#edf4ef",
      "warning": "#72581a",
      "warning-surface": "#fbf5e6",
      "danger": "#9e3343",
      "danger-surface": "#fbedef",
      "info": "#325771",
      "info-surface": "#eaf1f6"
    },
    "reward": {
      "points": "#e4bb55",
      "points-surface": "#f5e7c0",
      "on-points": "#1c332e",
      "points-ink": "#72581a",
      "streak": "#d2552f",
      "kudos": "#b83f52"
    },
    "person": {
      "clay": {
        "solid": "#ae4424",
        "on": "#f8f9f6",
        "soft": "#fdf0eb",
        "ink": "#87351d"
      },
      "sun": {
        "solid": "#e4bb55",
        "on": "#1c332e",
        "soft": "#fbf5e6",
        "ink": "#72581a"
      },
      "pine": {
        "solid": "#2e6f5a",
        "on": "#f8f9f6",
        "soft": "#e8f1ee",
        "ink": "#1f4a3e"
      },
      "lagoon": {
        "solid": "#3d6a8a",
        "on": "#f8f9f6",
        "soft": "#eaf1f6",
        "ink": "#284659"
      },
      "berry": {
        "solid": "#b83f52",
        "on": "#f8f9f6",
        "soft": "#fbedef",
        "ink": "#7e2936"
      },
      "plum": {
        "solid": "#6d6a8f",
        "on": "#f8f9f6",
        "soft": "#f1f0f6",
        "ink": "#45435c"
      },
      "meadow": {
        "solid": "#3f6b52",
        "on": "#f8f9f6",
        "soft": "#edf4ef",
        "ink": "#31543f"
      },
      "stone": {
        "solid": "#52635d",
        "on": "#f8f9f6",
        "soft": "#dde2dd",
        "ink": "#435550"
      }
    },
    "qr": {
      "paper": "#f8f9f6",
      "ink": "#0e1715"
    },
    "ambient": {
      "glow": "#eceeea",
      "sky": {
        "dawn": {
          "top": "#312f42",
          "bottom": "#87351d"
        },
        "day": {
          "top": "#284659",
          "bottom": "#3d6a8a"
        },
        "dusk": {
          "top": "#211f2d",
          "bottom": "#5e1f29"
        },
        "night": {
          "top": "#0e1715",
          "bottom": "#14242d"
        },
        "overcast": {
          "top": "#2c3c38",
          "bottom": "#52635d"
        },
        "cloud": "#dde2dd",
        "star": "#f5e7c0",
        "card": "#0e1715",
        "text": "#f8f9f6",
        "text-soft": "#eceeea",
        "sleep": {
          "bg": "#020303",
          "text": "#52635d"
        }
      }
    },
    "festive": {
      "candle": "#9e3343",
      "flame": "#e4bb55",
      "glow": "#edd28a",
      "gold": "#d9a632",
      "fir": "#1f4a3e",
      "fir-light": "#2e6f5a",
      "berry": "#b83f52",
      "snow": "#f8f9f6",
      "night-top": "#0e1715",
      "night-bottom": "#14242d",
      "party-top": "#211f2d",
      "party-bottom": "#5e1f29",
      "spring-top": "#284659",
      "spring-bottom": "#31543f",
      "meadow": "#3f6b52",
      "meadow-light": "#5a956c",
      "balloon1": "#b83f52",
      "balloon2": "#d9a632",
      "balloon3": "#4d82a7",
      "balloon4": "#5a956c",
      "balloon5": "#6d6a8f",
      "cake": "#f5b8a2",
      "icing": "#f8f9f6",
      "pumpkin": "#d2552f",
      "wood": "#513f13",
      "ink": "#0e1715"
    },
    "segment": {
      "track": "#dde2dd",
      "text": "#435550",
      "selected": "#f8f9f6",
      "on-selected": "#1c332e",
      "indicator": "#1f4a3e"
    }
  },
  "space": {
    "0": "0rem",
    "1": "0.25rem",
    "2": "0.5rem",
    "3": "0.75rem",
    "4": "1rem",
    "5": "1.25rem",
    "6": "1.5rem",
    "8": "2rem",
    "10": "2.5rem",
    "12": "3rem",
    "16": "4rem",
    "20": "5rem",
    "inset": {
      "xs": "0.5rem",
      "sm": "0.75rem",
      "md": "1rem",
      "lg": "1.5rem",
      "xl": "2rem"
    },
    "gap": {
      "xs": "0.25rem",
      "sm": "0.5rem",
      "md": "0.75rem",
      "lg": "1rem",
      "xl": "1.5rem"
    },
    "gutter": "clamp(1rem, 0.6rem + 1.8vw, 2.5rem)",
    "section": "clamp(1.5rem, 1rem + 2.4vw, 3.5rem)"
  },
  "radius": {
    "xs": "0.375rem",
    "sm": "0.625rem",
    "md": "0.875rem",
    "lg": "1.25rem",
    "xl": "1.75rem",
    "2xl": "2.25rem",
    "pill": "999px",
    "control": "0.625rem",
    "card": "0.875rem",
    "sheet": "1.25rem",
    "chip": "999px",
    "avatar": "999px"
  },
  "font": {
    "family": {
      "display": "'Schibsted Grotesk Variable', system-ui, sans-serif",
      "body": "'Schibsted Grotesk Variable', system-ui, sans-serif",
      "mono": "ui-monospace, SFMono-Regular, Menlo, monospace"
    },
    "weight": {
      "regular": 400,
      "medium": 500,
      "semibold": 600,
      "bold": 700,
      "black": 800
    },
    "leading": {
      "tight": 1.1,
      "snug": 1.25,
      "normal": 1.5
    }
  },
  "duration": {
    "instant": "80ms",
    "quick": "160ms",
    "base": "240ms",
    "slow": "420ms",
    "celebrate": "900ms"
  },
  "easing": {
    "standard": "cubic-bezier(0.2, 0, 0, 1)",
    "enter": "cubic-bezier(0, 0, 0.2, 1)",
    "exit": "cubic-bezier(0.4, 0, 1, 1)",
    "bounce": "cubic-bezier(0.34, 1.56, 0.64, 1)"
  },
  "size": {
    "touch": {
      "min": "3rem",
      "target": "3.5rem"
    },
    "icon": {
      "sm": "1.25rem",
      "md": "1.5rem",
      "lg": "2rem",
      "xl": "2.75rem"
    },
    "avatar": {
      "sm": "2.25rem",
      "md": "3rem",
      "lg": "4.5rem",
      "xl": "6.5rem"
    },
    "qr": "12rem",
    "column": {
      "card": "calc(17.5rem * var(--shh-scale-type))"
    },
    "content": {
      "narrow": "36rem",
      "medium": "48rem",
      "default": "64rem",
      "wide": "96rem"
    }
  },
  "scale": {
    "type": 1
  },
  "text": {
    "xs": "calc(0.8125rem * var(--shh-scale-type))",
    "sm": "calc(0.9375rem * var(--shh-scale-type))",
    "md": "calc(1.0625rem * var(--shh-scale-type))",
    "lg": "calc(clamp(1.1875rem, 1.1rem + 0.4vw, 1.375rem) * var(--shh-scale-type))",
    "xl": "calc(clamp(1.4rem, 1.2rem + 0.9vw, 1.875rem) * var(--shh-scale-type))",
    "2xl": "calc(clamp(1.75rem, 1.4rem + 1.6vw, 2.625rem) * var(--shh-scale-type))",
    "3xl": "calc(clamp(2.25rem, 1.6rem + 2.8vw, 3.75rem) * var(--shh-scale-type))",
    "4xl": "calc(clamp(3rem, 2rem + 5vw, 6.5rem) * var(--shh-scale-type))",
    "clock": "clamp(4rem, min(2rem + 12vw, 24dvh), 13rem)"
  },
  "motion": {
    "duration": {
      "instant": "80ms",
      "quick": "160ms",
      "base": "240ms",
      "slow": "420ms",
      "celebrate": "900ms"
    },
    "easing": {
      "standard": "cubic-bezier(0.2, 0, 0, 1)",
      "enter": "cubic-bezier(0, 0, 0.2, 1)",
      "exit": "cubic-bezier(0.4, 0, 1, 1)",
      "bounce": "cubic-bezier(0.34, 1.56, 0.64, 1)"
    }
  },
  "breakpoint": {
    "sm": "30rem",
    "md": "48rem",
    "lg": "64rem",
    "xl": "80rem",
    "2xl": "120rem"
  },
  "card": {
    "border": "1px",
    "press-offset": "0px"
  },
  "shadow": {
    "raised": "0 1px 2px #1C332E14",
    "floating": "0 4px 12px #1C332E1A, 0 12px 32px #1C332E14",
    "card": "none"
  }
};
export const personColors = ["clay","sun","pine","lagoon","berry","plum","meadow","stone"];
export const themes = ["light", "dark", "wall-night"];
export const profiles = ["picture", "kid", "teen"];
export const daylight = {
  "day": {
    "dawn": {
      "canvas": "#E4E9EE",
      "raised": "#F3F6F8",
      "sunken": "#E0E6EB",
      "subtle": "#D3DAE1",
      "glow": "#E9D3CF"
    },
    "sunrise": {
      "canvas": "#EEEAE6",
      "raised": "#FAF7F4",
      "sunken": "#E8E3DD",
      "subtle": "#DDD6CF",
      "glow": "#F7D2B8"
    },
    "morning": {
      "canvas": "#EAF0EE",
      "raised": "#F8FAF9",
      "sunken": "#DCE4E1",
      "subtle": "#D6DFDB",
      "glow": "#F4E4CC"
    },
    "noon": {
      "canvas": "#ECEEEA",
      "raised": "#F8F9F6",
      "sunken": "#DDE2DD",
      "subtle": "#DDE2DD",
      "glow": "#DCEAE6"
    },
    "evening": {
      "canvas": "#F0EBE2",
      "raised": "#FBF8F2",
      "sunken": "#EBE4D8",
      "subtle": "#E1D9CC",
      "glow": "#F0D9A6"
    },
    "sunset": {
      "canvas": "#EFE3DC",
      "raised": "#FAF3EF",
      "sunken": "#EBDFD7",
      "subtle": "#E0D0C7",
      "glow": "#EDB99F"
    },
    "dusk": {
      "canvas": "#E3DFE6",
      "raised": "#F3F0F5",
      "sunken": "#E2DDE6",
      "subtle": "#D4CED9",
      "glow": "#CFC1DB"
    }
  },
  "night": {
    "duskDark": {
      "canvas": "#0A0D14",
      "raised": "#10141D",
      "sunken": "#06080C",
      "subtle": "#1A1F2B",
      "glow": "#1C1830"
    },
    "deep": {
      "canvas": "#070B0A",
      "raised": "#0E1513",
      "sunken": "#040706",
      "subtle": "#18211E",
      "glow": "#0F1512"
    },
    "predawn": {
      "canvas": "#080C12",
      "raised": "#0F141B",
      "sunken": "#05070A",
      "subtle": "#19202A",
      "glow": "#141C2A"
    }
  }
};
